import { configureStore } from "@reduxjs/toolkit";
import headerSlice from "../features/common/headerSlice";
import modalSlice from "../features/common/modalSlice";
import rightDrawerSlice from "../features/common/rightDrawerSlice";
import leadsSlice from "../features/leads/leadSlice";
import languageSlice from "../features/common/languageSlice";
import stateModalSlice from "../features/common/bukkenSlice/stateModalSlice";
import stateBukkenSlice from "../features/common/bukkenSlice/stateBukken";
import stateBukkenMemberSlice from "../features/common/bukkenMemberSlice/stateBukkenMember";
import stateAdvancedInfo from "../features/common/bukkenSlice/stateAdvancedInfo";
import stateLoginInfo from "../features/common/loginSlice";
import statePatternSlice from "../features/common/bukkenSlice/statePatternItem";
import syncSlice from "../features/common/syncSlice";
import {
  listCompanySlice,
  companyInfoSlice,
  listUsernameSlice,
  folderChildrenSlice
} from "../features/common/file-storage-vaix";
import dailyAttendanceSlice from "../features/common/attendanceSlice/stateDailyAttendance";
import stateQuotationInvoiceSlice from "../features/common/quotation-invoice";
import photobookSlice from "../features/common/photobook";
import stateDocumentSlice from "../features/common/documents-repository/documents";
import stateBulletinSlice from "../features/common/documents-repository/bulletins";
import locationToastIdReducer from "../features/local_config_manage/SncLocationEdit/utils/locationToastIdSlice";
import logReducer from "../features/snc_admin/LogStatistic/utils/stores";
import stateWhiteBoardSlice, {
  loadStateWhiteBoard,
  localStorageMiddleware
} from "../features/whiteboard/whiteboardSlice";

const combinedReducer = {
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  lead: leadsSlice,
  language: languageSlice,
  listCompany: listCompanySlice,
  companyInfo: companyInfoSlice,
  listUserName: listUsernameSlice,
  folderChildren: folderChildrenSlice,
  stateModal: stateModalSlice,
  stateBukken: stateBukkenSlice,
  stateBukkenMember: stateBukkenMemberSlice,
  stateAdvancedInfo: stateAdvancedInfo,
  stateLoginInfo: stateLoginInfo,
  statePattern: statePatternSlice,
  sync: syncSlice,
  stateDailyAtd: dailyAttendanceSlice,
  stateQuotationInvoice: stateQuotationInvoiceSlice,
  photobookStore: photobookSlice,
  stateDocuments: stateDocumentSlice,
  stateBulletins: stateBulletinSlice,
  locationToast: locationToastIdReducer,
  logStatistic: logReducer,
  stateWhiteBoard: stateWhiteBoardSlice
};

const preloadedWhiteBoardState = loadStateWhiteBoard();

export default configureStore({
  reducer: combinedReducer,
  preloadedState: preloadedWhiteBoardState,
  // config to ignore non-serializable warnings.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(localStorageMiddleware)
});
